import { ComponentType, forwardRef } from 'react';
import { MakeOptional } from '~/lib/tsTools';

function withProps<P, PP extends Partial<P>>(
  Component: ComponentType<P>,
  initialProps: PP
): ComponentType<MakeOptional<P, keyof PP>> {
  return forwardRef<any, any>((props, ref) => <Component ref={ref} {...initialProps} {...props} />) as any;
}

export default withProps;
